var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/utils.ts
import Cookies from "universal-cookie";
var GDPR_PREFERENCES_COOKIE = {
  wkda: "gdpr_preferences",
  autohero: "consent"
};
var SCID_COOKIE = {
  wkda: "SCID",
  autohero: "SESSID"
};
var CID_COOKIE = {
  wkda: "WKDA",
  autohero: "AUTOHERO"
};
var QUERY_PARAM_UTM_EXPID = "utm_expid";
var getScidCookieValue = /* @__PURE__ */ __name((appname) => {
  const cookieService = new Cookies();
  return cookieService.get(SCID_COOKIE[appname]);
}, "getScidCookieValue");
var getCidCookieValue = /* @__PURE__ */ __name((appname) => {
  const cookieService = new Cookies();
  return cookieService.get(CID_COOKIE[appname]);
}, "getCidCookieValue");
var isAnalyticalCookieSet = /* @__PURE__ */ __name((appname) => {
  var _a;
  const cookieService = new Cookies();
  const GDPRPreferencesCookie = cookieService.get(
    GDPR_PREFERENCES_COOKIE[appname]
  );
  if (appname === "wkda") {
    return (_a = GDPRPreferencesCookie == null ? void 0 : GDPRPreferencesCookie.categories) == null ? void 0 : _a.includes("analytical");
  }
  if (appname === "autohero") {
    return GDPRPreferencesCookie == null ? void 0 : GDPRPreferencesCookie.includes("1");
  }
  return false;
}, "isAnalyticalCookieSet");
var getUtmExpid = /* @__PURE__ */ __name(() => {
  var _a;
  const searchParams = new URLSearchParams((_a = window.location) == null ? void 0 : _a.search);
  return searchParams.get(QUERY_PARAM_UTM_EXPID) || searchParams.get(`${QUERY_PARAM_UTM_EXPID}[]`);
}, "getUtmExpid");
var getExperiments = /* @__PURE__ */ __name(() => {
  var _a;
  const searchParams = new URLSearchParams((_a = window.location) == null ? void 0 : _a.search);
  const utmExpIdParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key === QUERY_PARAM_UTM_EXPID || key === `${QUERY_PARAM_UTM_EXPID}[]`) {
      utmExpIdParams.push(value);
    }
  }
  if (utmExpIdParams.length === 0)
    return;
  return utmExpIdParams.map((experiment) => {
    const [, id, variant] = experiment.split(".");
    return { id, variant };
  });
}, "getExperiments");

// src/marketing-tracking-service.ts
var parseAppName = /* @__PURE__ */ __name((params) => {
  var _a;
  return ((_a = params.appname) == null ? void 0 : _a.includes("@retail")) ? "autohero" : "wkda";
}, "parseAppName");
var parseTrackingParams = /* @__PURE__ */ __name((params) => {
  return __spreadProps(__spreadValues({}, params), {
    appname: parseAppName(params)
  });
}, "parseTrackingParams");
var baseTrackLandingParams = /* @__PURE__ */ __name(() => {
  const { screen, location } = window;
  const experiments = getExperiments();
  let experimentPayload = {};
  if (experiments && experiments.length > 0) {
    experimentPayload = {
      currentExperiment: experiments
    };
  }
  return __spreadProps(__spreadValues({}, experimentPayload), {
    screenSize: {
      width: screen.width,
      height: screen.height
    },
    referrer: (location == null ? void 0 : location.origin) + (location == null ? void 0 : location.pathname),
    landingPageName: location == null ? void 0 : location.pathname,
    currentUrl: location == null ? void 0 : location.href
  });
}, "baseTrackLandingParams");
var defaultTrackLandingParams = /* @__PURE__ */ __name((appname) => {
  var _a, _b;
  const experiments = getExperiments();
  let experimentPayload = {};
  if (experiments && experiments.length > 0) {
    experimentPayload = {
      currentExperimentId: (_a = experiments[experiments.length - 1]) == null ? void 0 : _a.id,
      currentVariant: (_b = experiments[experiments.length - 1]) == null ? void 0 : _b.variant,
      currentExperiment: experiments
    };
  }
  return __spreadProps(__spreadValues(__spreadValues({
    action: "landing"
  }, baseTrackLandingParams()), experimentPayload), {
    scid: getScidCookieValue(appname),
    cid: getCidCookieValue(appname)
  });
}, "defaultTrackLandingParams");
var defaultTrackLeadFieldChangedParams = /* @__PURE__ */ __name((appname) => {
  var _a, _b;
  const { screen, location } = window;
  const experiments = getExperiments();
  let experimentPayload = {};
  if (experiments && experiments.length > 0) {
    experimentPayload = {
      currentExperimentId: (_a = experiments[experiments.length - 1]) == null ? void 0 : _a.id,
      currentVariant: (_b = experiments[experiments.length - 1]) == null ? void 0 : _b.variant,
      currentExperiment: experiments
    };
  }
  return __spreadProps(__spreadValues({
    action: "field-changed"
  }, experimentPayload), {
    screenSize: {
      width: screen.width,
      height: screen.height
    },
    landingPageName: location == null ? void 0 : location.pathname,
    currentUrl: location == null ? void 0 : location.href,
    scid: getScidCookieValue(appname)
  });
}, "defaultTrackLeadFieldChangedParams");
var defaultTrackExternalParams = /* @__PURE__ */ __name((appname) => {
  return {
    cid: getCidCookieValue(appname),
    scid: getScidCookieValue(appname)
  };
}, "defaultTrackExternalParams");
function shouldIncludeLandingParams(params) {
  return ["booking-landing"].includes(params.action);
}
__name(shouldIncludeLandingParams, "shouldIncludeLandingParams");
var MarketingTrackingService = class {
  constructor(httpClient, logger) {
    this.httpClient = httpClient;
    this.logger = logger;
  }
  trackLanding(params) {
    const parsedParams = parseTrackingParams(params);
    const isUtmExpid = !!getUtmExpid();
    const isAnalyticalCookieAllowed = isAnalyticalCookieSet(
      parsedParams.appname
    );
    if (isUtmExpid && isAnalyticalCookieAllowed) {
      this.httpClient.post(
        "/v1/marketing-frontend-tracking/marketing-frontend-experiment",
        __spreadValues(__spreadValues({}, defaultTrackLandingParams(parsedParams.appname)), parsedParams)
      );
    }
  }
  trackLeadFieldChanged(params) {
    const parsedParams = parseTrackingParams(params);
    const isAnalyticalCookieAllowed = isAnalyticalCookieSet(
      parsedParams.appname
    );
    if (isAnalyticalCookieAllowed) {
      this.httpClient.post("/v1/marketing-frontend-tracking/lead-form", __spreadValues(__spreadValues({}, defaultTrackLeadFieldChangedParams(parsedParams.appname)), parsedParams));
    }
  }
  trackExternal(urlParams, params) {
    var _a;
    const { location, navigator } = window;
    const parsedParams = __spreadProps(__spreadValues({}, params), { appname: parseAppName(params) });
    const isAnalyticalCookieAllowed = isAnalyticalCookieSet(
      parsedParams.appname
    );
    if (isAnalyticalCookieAllowed) {
      const { externalType, externalId } = urlParams;
      const defaultParams = defaultTrackExternalParams(parsedParams.appname);
      const payload = __spreadValues(__spreadValues(__spreadValues({}, defaultParams), shouldIncludeLandingParams(parsedParams) ? baseTrackLandingParams() : {}), parsedParams);
      if (defaultParams.scid && defaultParams.cid) {
        this.httpClient.post(
          `/v1/marketing-frontend-tracking/${externalType}/${externalId}`,
          payload
        );
      } else {
        let message = "[marketing-tracking] missing parameters: ";
        if (!defaultParams.scid) {
          message += "`scid` is missing; ";
        }
        if (!defaultParams.cid) {
          message += "`cid` is missing; ";
        }
        message += `payload: ${JSON.stringify(payload)}`;
        const error = new Error(message);
        if ((_a = this.logger) == null ? void 0 : _a.error) {
          this.logger.error({
            error,
            message,
            meta: {
              errorType: "tracking-error",
              currentUrl: location == null ? void 0 : location.href,
              userAgent: navigator == null ? void 0 : navigator.userAgent
            }
          });
        } else {
          console.error(message);
          console.warn(
            "marketing-tracking-service is missing `logger` dependency"
          );
        }
      }
    }
  }
};
__name(MarketingTrackingService, "MarketingTrackingService");
export {
  MarketingTrackingService
};
//# sourceMappingURL=index.mjs.map